import { store } from '@src/state/store';
import { updateConnectedPlayers } from '@src/state/slices/slice_app';

interface GlobalDetails {
  connectedPlayers: number;
}

export default () => (data: GlobalDetails) => {
  store.dispatch(updateConnectedPlayers(data.connectedPlayers));
};
